import { render, staticRenderFns } from "./ProjectSelectRoadBlock.vue?vue&type=template&id=2889adb7&scoped=true"
import script from "./ProjectSelectRoadBlock.vue?vue&type=script&lang=js"
export * from "./ProjectSelectRoadBlock.vue?vue&type=script&lang=js"
import style0 from "./ProjectSelectRoadBlock.vue?vue&type=style&index=0&id=2889adb7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2889adb7",
  null
  
)

export default component.exports